import React from "react";
import { Scale, GraduationCap, Gavel } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_59327c5f-9084-4487-a3b9-37467c30053c/artifacts/09w9qdg0_IMG_5550.jpeg";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#262321] hairline-t hairline-b overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -top-6 -right-6 hidden md:block">
              <div className="overline writing-mode-vertical text-right">
                Mansfield · Est. Experience
              </div>
            </div>

            <div className="image-frame border border-[#C89D54]/20">
              <img
                data-testid="about-portrait"
                src={ABOUT_IMG}
                alt="Michael Skierniewski at his desk"
                className="w-full h-[420px] md:h-[520px] object-cover"
                loading="lazy"
              />
            </div>

            <div className="absolute -bottom-6 left-6 right-6 md:left-12 md:right-12 bg-[#1A1918] border border-[#C89D54]/30 p-6 md:p-7">
              <div className="overline mb-2">A note from Michael</div>
              <p className="font-serif-display italic text-lg md:text-xl text-[#F4F0EB] leading-snug">
                &ldquo;Clear, honest and straightforward — no jargon, no
                false promises.&rdquo;
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#C89D54]" />
            <span className="overline">About Me</span>
          </div>

          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] tracking-tight leading-[1.05]">
            Two sides of the courtroom.
            <span className="block italic text-[#C89D54] mt-2">
              One person to guide you.
            </span>
          </h2>

          <div className="mt-8 space-y-5 font-sans-body text-[#A6A098] text-base leading-relaxed max-w-2xl">
            <p data-testid="about-paragraph-1">
              I am a local Professional McKenzie Friend based near Mansfield.
              With over 15 years of experience working as a bailiff, I have
              developed a deep understanding of court processes, enforcement
              and the practical side of the legal system.
            </p>
            <p data-testid="about-paragraph-2">
              I have completed specialist McKenzie Friend training and obtained
              an LLB (Honours) Law degree. This combination
              of practical courtroom experience and legal education allows me
              to provide high-quality support to litigants in person in the
              Family Court.
            </p>
            <p data-testid="about-paragraph-3" className="text-[#F4F0EB]">
              My approach is clear, honest and straightforward. I help people
              who are facing difficult family court proceedings and need
              someone who understands both the law and the system.
            </p>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {[
              { Icon: Gavel, label: "15+ years bailiff" },
              { Icon: GraduationCap, label: "LLB (Honours) Law" },
              { Icon: Scale, label: "McKenzie trained" },
            ].map(({ Icon, label }, i) => (
              <div
                key={label}
                data-testid={`about-credential-${i}`}
                className="border border-[#C89D54]/20 p-4 flex items-center gap-3 hover:border-[#C89D54]/50 transition-colors"
              >
                <Icon size={20} className="text-[#C89D54] shrink-0" />
                <span className="text-sm font-medium text-[#F4F0EB]">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
